import React, { useEffect, useState } from "react";
import "./cok-header-right.m.css";
import MyAccount from "../../../../molecules/my-account";
import Modal from "../../../../atoms/modal";
import HamburgerAndSearch from "../../../../atoms/hamburger-and-search";
import { useSelector } from "react-redux";
import { get } from "lodash";
import CokSigninButton from "./cok-signin-button";
import CokMyAccountButton from "./cok-my-account-button";

function CokHeaderRight() {
  const [showModal, setShowModal] = useState("");
  const isUserLogin = useSelector((state) => get(state, ["isLogin"], false));

  useEffect(() => {
    const isProfileOpen = window.localStorage.getItem("isProfileOpen");

    setShowModal(isProfileOpen);
  }, [showModal]);
  const openModal = () => {
    setShowModal("true");
    localStorage.setItem("isProfileOpen", "true");
  };
  const closeModal = () => {
    setShowModal("false");
    localStorage.setItem("isProfileOpen", "false");
  };
  return (
    <>
      <div styleName="row row2">
        {!isUserLogin && isUserLogin !== undefined && isUserLogin !== null ? (
          <CokSigninButton />
        ) : (
          <CokMyAccountButton onAccountHandler={openModal} />
        )}
        <Modal onClose={closeModal} isOpen={showModal == "true" ? true : false}>
          <MyAccount closeModal={closeModal} />
        </Modal>
        <HamburgerAndSearch />
      </div>
    </>
  );
}

export default CokHeaderRight;
